export default{
    skin_list : [{id : 'FS72', name : '金牌龙王'},{id : 'FS76', name : '金牌大帝'},{id : 'FS68', name : '金牌飞鸿'},{id : 'FS70', name : '金牌军师'},{id : 'FS66', name : '金牌荣光'}],
    skin_shop : [
        {},
        {},
        {},
        {},
    ],
}